import React, { useState, useEffect } from "react";
import { CircularProgress, Box, Typography, Button } from "@mui/material";
import axios from "../../../../../api/axios";

function ViewId({ fileName }) {
	const [loading, setLoading] = useState(false);
	const [fileUrl, setFileUrl] = useState(null);
	const [error, setError] = useState("");
	const [fileType, setFileType] = useState(null);

	// Cleanup object URL on unmount or file change
	useEffect(() => {
		return () => {
			if (fileUrl) {
				URL.revokeObjectURL(fileUrl);
			}
		};
	}, [fileUrl]);

	const fetchFile = async () => {
		if (!fileName) {
			setError("File name is missing");
			return;
		}

		// Reset previous states
		setError("");
		if (fileUrl) {
			URL.revokeObjectURL(fileUrl);
			setFileUrl(null);
			setFileType(null);
		}

		setLoading(true);
		try {
			const response = await axios.get(`/image/${fileName}`, {
				responseType: "blob",
			});

			const blob = response.data;
			const objectUrl = URL.createObjectURL(blob);
			const contentType = response.headers["content-type"] || blob.type;

			setFileType(contentType);
			setFileUrl(objectUrl);
		} catch (err) {
			console.error(err);
			setError(
				err.response?.status === 404
					? "File not found"
					: "Failed to fetch the file"
			);
		} finally {
			setLoading(false);
		}
	};

	const handleShowFile = () => {
		fetchFile();
	};

	const handleDownload = () => {
		if (fileUrl && fileType) {
			const link = document.createElement("a");
			link.href = fileUrl;
			// Optionally, set filename for download
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	};

	console.log(fileType);
	console.log(fileUrl);

	return (
		<Box
			sx={{ maxWidth: 700, margin: "auto", padding: 3, textAlign: "center" }}>
			<Typography variant="h4" gutterBottom>
				View Stored File
			</Typography>
			<Button
				variant="contained"
				onClick={handleShowFile}
				disabled={loading}
				sx={{ mb: 2, mr: 2 }}>
				{loading ? <CircularProgress size={24} /> : "Show File"}
			</Button>
			{/* Download Button */}
			{fileUrl && (
				<Button variant="outlined" onClick={handleDownload} sx={{ mb: 2 }}>
					Download
				</Button>
			)}

			{error && (
				<Typography color="error" sx={{ mb: 2 }}>
					{error}
				</Typography>
			)}

			{fileUrl && (
				<Box
					sx={{
						mt: 4,
						display: "flex",
						justifyContent: "center",
						flexDirection: "column",
						alignItems: "center",
					}}>
					{fileType && fileType.startsWith("image") ? (
						<img
							src={fileUrl}
							alt="Fetched"
							style={{
								maxWidth: "100%",
								height: "auto",
								borderRadius: 8,
								boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
							}}
						/>
					) : fileType &&
					  (fileType === "application/pdf" ||
							fileType.startsWith("application")) ? (
						<iframe
							src={fileUrl}
							title="File Preview"
							width="100%"
							height="600px"
							style={{
								border: "none",
								borderRadius: 8,
								boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
							}}
						/>
					) : (
						<Typography>Cannot preview this file type.</Typography>
					)}
				</Box>
			)}
		</Box>
	);
}

export default ViewId;
